import PropTypes from 'prop-types';
import React from 'react';

const QuestionComponent = (props) => (
  <div>
    <h2 className="h2-alt">
      Възстанови жизнения си баланс
    </h2>
    <div className="offset-bottom">
      <p>
        <i>
          Разберете каква е вашата индивидуална конституция с помощта на теста, който ви предлагаме и опознайте по-добре себе си. Научете как да поддържате своята физика и психика в перфектен баланс с вашата собствена природа, като следвате съветите, които ви подхождат.
        </i>
      </p>
      <p>
        <strong>Интерактивният аюрведичен доша тест ще ви помогне да научите какво е вашето настоящо индивидуално съотношение между трите основни биологични принципа -  Вата, Пита и Кафа, които определят психосоматичните характеристики на всяко човешко същество. </strong>
        Тестът започва след натискане на бутона „Започване на теста“. Моля, изберете бутона с отговор, който най-добре ви описва. След като отговорите на всичките 35 въпроса, тестът ще покаже вашето индивидуално съотношение между трите доши.
      </p>
      <p>
        Например, ако имате резултат със съотношение 60% Вата, 30% Пита, 10% Кафа, това означава, че сте преобладаващ Вата тип и за вас е подходящо да адаптирате диетата, начина си на живот и работата в съответствие с тази конституция. Повечето хора имат една доминираща доша. В някои случаи две доши могат да бъдат еднакво представени (комбиниран тип) и много рядко и трите доши присъстват еднакво (тридоша).
      </p>
      <p>
        След като завършите теста, може да приложите резултатите си, за да откриете характеристики и препоръки за конкретната доша (Вата, Пита или Кафа) или за комбинирани типове, ако две доши са в подобен процент на присъствие.
      </p>
    </div>
    <button
      className="btn btn-default"
      onClick={props.onContinueClick}
    >
      Започване на теста
    </button>
  </div>
);

QuestionComponent.propTypes = {
  onContinueClick: PropTypes.func.isRequired,
  questionCount: PropTypes.number.isRequired,
};

export default QuestionComponent;
